import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Breadcrumb from "../../../components/layout/Breadcrumb";
import { fetchAnnouncements, fetchAnnouncementById } from "../../../redux/slice/announcementsSlice";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import PopupState, { bindTrigger, bindMenu } from "material-ui-popup-state";
import { useHasPermission } from "../../../hooks/useHasPermission";
import AnnouncementPreviewModal from "./AnnouncementPreviewModal";
import { cleanText } from "utils/cleanText";

export default function AnnouncementList() {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [showViewModal, setShowViewModal] = useState(false);
    const [displayedAnnouncements, setDisplayedAnnouncements] = useState([]);

    const [sortField, setSortField] = useState("id");
    const [sortOrder, setSortOrder] = useState("dsc");
    const [statusCycleIndex, setStatusCycleIndex] = useState(0);

    const getSortedAnnouncements = () => {
        if (!displayedAnnouncements?.length) return [];

        return [...displayedAnnouncements].sort((a, b) => {
            let valueA = a[sortField];
            let valueB = b[sortField];

            if (sortField === "publishAt" || sortField === "createdAt") {
                valueA = valueA ? new Date(valueA).getTime() : 0;
                valueB = valueB ? new Date(valueB).getTime() : 0;
            }

            if (sortField === "status") {
                const statusOrders = [
                    { DRAFT: 1, SCHEDULED: 2, PUBLISHED: 3 },
                    { SCHEDULED: 1, PUBLISHED: 2, DRAFT: 3 },
                    { PUBLISHED: 1, DRAFT: 2, SCHEDULED: 3 }
                ];

                const currentOrder = statusOrders[statusCycleIndex];
                valueA = currentOrder[valueA] ?? 99;
                valueB = currentOrder[valueB] ?? 99;
            }

            if (valueA < valueB) return sortOrder === "asc" ? -1 : 1;
            if (valueA > valueB) return sortOrder === "asc" ? 1 : -1;
            return 0;
        });
    };

    const { list = [], loading, error, selected = null } = useSelector(
        (state) => state.announcements
    );
    const canView = useHasPermission("Announcements-view");
    const canManage = useHasPermission("Announcements-manage");

    const handleSort = (field) => {

        if (field === "status") {
            setSortField("status");
            setStatusCycleIndex((prev) => (prev + 1) % 3);
            return;
        }

        if (sortField === field) {
            setSortOrder(sortOrder === "asc" ? "desc" : "asc");
        } else {
            setSortField(field);
            setSortOrder("asc");
        }
    };
    /* FETCH LIST ================= */
    useEffect(() => {
        if (!canView) return;
        dispatch(fetchAnnouncements());
    }, [dispatch, canView]);

    useEffect(() => {
        setDisplayedAnnouncements(list);
    }, [list]);

    const handleCreate = () => {
        if (!canManage) {
            toast.error("You don't have permission to create announcements", { className: 'toast-error-custom' });
            return;
        }
        navigate("/admin/announcements/create");
    };

    const handleView = (id) => {
        dispatch(fetchAnnouncementById(id));
        setShowViewModal(true
            
        );
    };

    const handleEdit = (id) => {
        if (!canManage) {
            toast.error("You don't have permission to edit announcements", { className: 'toast-error-custom' });
            return;
        }
        navigate(`/admin/announcements/${id}/edit`);
    };

    /* NO PERMISSION ================= */
    if (!canView) {
        return (
            <p className="perm-msg">
                You don't have permission to view announcements!
            </p>
        );
    }

    return (
        <div className="container-fluid" style={{ marginBottom: "30px" }}>
             <Breadcrumb />

            <div className=" d-flex justify-content-between align-items-center" style={{ flexDirection: "row-reverse", marginBottom: "18px" }}>
                <div className="icons-list">
                   
                    <h5 className="mb-3 mt-1 d-none-m">Company Announcement</h5>
                    {canManage && (
                        <div> <button type="button" className="primary-btn ml-4" onClick={handleCreate}>
                            <i className="fe fe-plus"></i>+ Create Announcement
                        </button>
                        </div>
                    )}
                </div>
            </div>
            <div className="section-body">
                <div className="container-fluid">
                    <div className="tab-content">
                        <div className="tab-pane fade active show">
                            <div className="card-policy">
                                <div className="card-body pt-0 pb-0">
                                    <div className="announcement-container table-responsive m-0">
                                        <table id="announcement-list" className="announcement-list table table-bordered table-hover table-vcenter text-nowrap mb-0" >
                                            <thead>
                                                <tr>
                                                    <th onClick={() => handleSort("id")} style={{ cursor: "pointer", width: "45px", textAlign: "center" }}>
                                                        ID {sortField === "id" ? (sortOrder === "asc" ? "▲" : "▼") : ""}
                                                    </th>
                                                    <th>Title</th>
                                                    <th>Description</th>
                                                     <th onClick={() => handleSort("createdAt")} style={{ cursor: "pointer", width: "110px", textAlign: "center" }}>
                                                        Created At {sortField === "createdAt" ? (sortOrder === "asc" ? "▲" : "▼") : ""}
                                                    </th>
                                                    <th onClick={() => handleSort("publishAt")} style={{ cursor: "pointer", width: "110px", textAlign: "center" }}>
                                                        Publish At {sortField === "publishAt" ? (sortOrder === "asc" ? "▲" : "▼") : ""}
                                                    </th>

                                                    <th onClick={() => handleSort("status")} style={{ cursor: "pointer", width: "55px", textAlign: "center" }}>
                                                        Status {sortField === "status" ? (sortOrder === "asc" ? "▲" : "▼") : ""}
                                                    </th>

                                                    <th style={{ width: "10px", textAlign: "center" }}>Action</th>


                                                    {/* <th style={{ width: "45px", textAlign: "center" }}>ID</th> */}

                                                    {/* <th>Type</th> */}
                                                    {/* <th style={{ width: "55px", textAlign: "center" }}>Publish At</th>
                                                    <th style={{ width: "55px", textAlign: "center" }}>Created At</th>
                                                    <th style={{ width: "55px", textAlign: "center" }}>Status</th> */}
                                                </tr>
                                            </thead>

                                            <tbody>
                                                {error && (
                                                    <tr>
                                                        <td colSpan="8" className="text-center">
                                                            <p className="server-error-msg">-- Unable to connect to server --</p>
                                                        </td>
                                                    </tr>
                                                )}

                                                {!error && loading && (
                                                    <tr>
                                                        <td colSpan="8" className="text-center">
                                                            <p className="loading-msg">Loading announcements...</p>
                                                        </td>
                                                    </tr>
                                                )}

                                                {!error && !loading && displayedAnnouncements.length === 0 && (
                                                    <tr>
                                                        <td colSpan="8" className="text-center">
                                                            <p className="server-error-msg">-- No announcements found --</p>
                                                        </td>
                                                    </tr>
                                                )}

                                                {!loading && displayedAnnouncements.length > 0 &&
                                                    getSortedAnnouncements().map((item) => {
                                                        const cleanContent = cleanText(item.content);
                                                        const statusClasses = {
                                                            PUBLISHED: "bg-success",
                                                            SCHEDULED: "bg-warning text-dark",
                                                            DRAFT: "bg-secondary"
                                                        };

                                                        const badgeClass =
                                                            statusClasses[item.status] || "bg-secondary";

                                                        return (
                                                            <tr key={item.id}>
                                                                <td>{item.id}</td>
                                                                <td>{item.title || "-"}</td>
                                                                <td className="text-left" style={{ textAlign: "left" }}>{cleanContent.length > 150 ? `${cleanContent.slice(0, 150)}...` : cleanContent}</td>
                                                                {/* <td>{item.type || "-"}</td> */}
                                                                <td>{item.createdAt ? new Date(item.createdAt).toLocaleString() : "-"}</td>
                                                                <td>{item.publishAt ? new Date(item.publishAt).toLocaleString() : "-"}</td>
                                                                <td>
                                                                    <span className={`badge ${badgeClass}`}>
                                                                        {item.status || "DRAFT"}
                                                                    </span>
                                                                </td>
                                                                <td className="text-center">
                                                                    <PopupState variant="popover" popupId={`announcement-action-${item.id}`}>
                                                                        {(popupState) => (
                                                                            <>
                                                                                <button type="button" className="btn btn-icon btn-sm icons" {...bindTrigger(popupState)} title="Actions" >
                                                                                    <img src={require("assets/img/more.png")} alt="actions" className="action-icon" />
                                                                                </button>
                                                                                <Menu {...bindMenu(popupState)}>
                                                                                    <MenuItem onClick={() => { popupState.close(); handleView(item.id); }}>
                                                                                        <button type="button" className="btn btn-icon btn-sm icons"
                                                                                            title={canView ? "view" : "No permission"}
                                                                                            disabled={!canView} >
                                                                                            <img src={require("assets/img/view-icon.png")} alt="view" className="action-icon" style={{ width: 15, opacity: canView ? 1 : 0.5, }} />
                                                                                        </button>
                                                                                        View
                                                                                    </MenuItem>

                                                                                    {canManage && (
                                                                                        <MenuItem onClick={() => { popupState.close(); handleEdit(item.id); }}>
                                                                                            <button type="button" className="btn btn-icon btn-sm icons" disabled={!canManage}
                                                                                                title={canManage ? "edit" : "No permission"} >
                                                                                                <img src={require("assets/img/edit-icon.png")} alt="Edit" className="action-icon me-2" style={{ width: 15, opacity: canManage ? 1 : 0.5, }} />
                                                                                            </button>
                                                                                            Edit
                                                                                        </MenuItem>
                                                                                    )}
                                                                                </Menu>
                                                                            </>
                                                                        )}
                                                                    </PopupState>
                                                                </td>
                                                            </tr>
                                                        );
                                                    })}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* MODAL ================= */}
            <AnnouncementPreviewModal
                show={showViewModal}
                onHide={() => setShowViewModal(false)}
                announcementId={selected?.id || null}
                canEdit={canManage}
                onEdit={handleEdit}
            />
            <ToastContainer />
        </div>
    );
}
